// Preloader
window.addEventListener('load', function() {
  var p = document.getElementById('vl-preloader');
  if (p) setTimeout(function() { p.classList.add('is-hidden'); }, 100);
});

var $j = jQuery.noConflict();

// public vars
var header_height;



///////////////////////////
//// jQuery doc ready /////
///////////////////////////


$j(document).ready(function(){

	// ============================================================
	// Venus Living — Header interactions
	// ============================================================

	// Sticky header scroll class
	var siteHeader = document.getElementById('site-header');
	if (siteHeader) {
		$j(window).on('scroll', function() {
			if ($j(window).scrollTop() > 30) {
				siteHeader.classList.add('site-header--scrolled');
			} else {
				siteHeader.classList.remove('site-header--scrolled');
			}
		});
	}

	// Mobile burger toggle
	var burger = document.getElementById('site-burger');
	var mobileNav = document.getElementById('mobile-nav');
	if (burger && mobileNav) {
		burger.addEventListener('click', function() {
			var expanded = this.getAttribute('aria-expanded') === 'true';
			this.setAttribute('aria-expanded', !expanded);
			mobileNav.classList.toggle('is-open');
			mobileNav.setAttribute('aria-hidden', expanded);
			document.body.classList.toggle('nav-open');
		});
	}

	// Mobile accordion toggle
	$j('.mobile-nav__accordion-toggle').on('click', function() {
		var expanded = $j(this).attr('aria-expanded') === 'true';
		$j(this).attr('aria-expanded', !expanded);
		$j(this).next('.mobile-nav__sub').attr('aria-hidden', expanded);
	});

	// Language dropdown toggle
	$j('.site-header__lang-toggle').on('click', function(e) {
		e.stopPropagation();
		var expanded = $j(this).attr('aria-expanded') === 'true';
		$j(this).attr('aria-expanded', !expanded);
	});

	// Close lang dropdown on outside click
	$j(document).on('click', function() {
		$j('.site-header__lang-toggle').attr('aria-expanded', 'false');
	});

	$j('.site-header__lang').on('click', function(e) {
		e.stopPropagation();
	});

	// FAQ Accordion toggle
	$j('.faq-item__q').on('click', function() {
		var item = $j(this).closest('.faq-item');
		var wasOpen = item.hasClass('is-open');

		// Close all
		$j('.faq-item').removeClass('is-open');
		$j('.faq-item__q').attr('aria-expanded', 'false');
		$j('.faq-item__a').attr('aria-hidden', 'true');

		// Toggle clicked
		if (!wasOpen) {
			item.addClass('is-open');
			$j(this).attr('aria-expanded', 'true');
			item.find('.faq-item__a').attr('aria-hidden', 'false');
		}
	});

	// Filter-Bar — update URL params on change
	$j('.filter-select').on('change', function() {
		var params = new URLSearchParams(window.location.search);
		var filterName = $j(this).data('filter');
		var val = $j(this).val();

		if (val) {
			params.set(filterName, val);
		} else {
			params.delete(filterName);
		}

		var newUrl = window.location.pathname;
		var qs = params.toString();
		if (qs) newUrl += '?' + qs;
		window.location.href = newUrl;
	});

	// Gallery — thumbnail click handler
	$j('.gallery-thumb').on('click', function() {
		var wrap = $j(this).closest('.gallery-wrap');
		var mainImg = wrap.find('.gallery-main__img');
		var caption = wrap.find('.gallery-main__caption');
		var idx = parseInt($j(this).data('index'), 10);
		var total = parseInt($j(this).data('total'), 10);

		mainImg.attr('src', $j(this).data('src'));
		mainImg.attr('alt', $j(this).data('alt'));

		var capText = $j(this).data('caption');
		if (capText) {
			caption.text(capText + ' (' + (idx + 1) + ' / ' + total + ')').show();
		} else {
			caption.hide();
		}

		wrap.find('.gallery-thumb').removeClass('is-active');
		$j(this).addClass('is-active');
	});

	// Hero Vollbild — headline rotation is now CSS-only (@keyframes rotateWord)



	// scroll to next section
	$j('.scrolldown').click(function(){
		var nextSection = $j(this).closest('section').next();
		scrollTo(nextSection);
	});


	// WPCF7
	$j('.wpcf7-form-control').focus(function(){
		$j(this).closest('[class*="col"]').find('label').addClass('active');
	});

	$j('.wpcf7-form-control').blur(function(){
		if($j(this).val() == ''){
			$j(this).closest('[class*="col"]').find('label').removeClass('active');
		}
	});

	// hash scroll links
	$j('a[href^="#"]').on('click',function(e){
		e.preventDefault();
		var href = $j(this).attr('href');
		if( href !== '#gdpr' && href !== '#cn-accept' && href !== '#imprint' ){
			checkHashScroll($j(this));
			console.log('scroll');
		}else{
			console.log('foo');
		}
	});

	// back to top button
	 $j('#btt').click(function(){
		scrollTo();
	 });




  // Legacy faq__section removed — using .faq-item__q toggle above



});

///////////////////////////
//////// EVENTS ///////////
///////////////////////////

// Vars needed in events
// needed for isElementInViewport
var lastPos = 0;


/*
* 	@ Scroll
*/

$j(window).on('scroll', function() {

	// jquery because of Crossbrowser
	var scrollY = $j(window).scrollTop();

	fixedHeader();
	animateElems();




// UPCOUNT
var counterElements = $j(".counter");
counterElements.each(function() {
    var counterElement = $j(this);
    if (counterElement.data("counted") !== true && isElementInViewport(counterElement[0])) {
        var targetValue = counterElement.data("count");
        countToValue(counterElement, targetValue);
        counterElement.data("counted", true);
    }
});




	/*
	* Singlepage history push if needed
	*/

	// history push data array
	// var control = {'title':active_section_title,'id':section_id};

	// push in history
	// history.pushState(control,null,section_id);

	// set title ( via push currently not supported in browsers )
	// document.title = active_section_title;

	// assign last, so that other operations before can reference on last scroll position
	lastPos = scrollY;

});


/*
* 	@ PageLoadeffect if needed
*/

// $j(window).on('beforeunload',function(){
// 	$j('.wrapper').removeClass('page--loaded');
// });


/*
*	@ Window Load if needed for any fallback classes or similar
*/

$j(window).on('load', function() {

	// get header height
	header_height = 0;

	// dynamic padding for header height
	//$j('body').css( 'padding-top', ( header_height - 2 + 'px' ) ); // 2 px offset, so that no gap will occur

	// user agent var for os dependant fixes
	// var ua = window.navigator.userAgent;

	// iOS fixes
	// var iOS = /iPad|iPhone|iPod/.test(ua) && !window.MSStream;
	// if(iOS) document.body.className += ' ios';

	// ie user agent, for ie fixes via body class
	// var isIE = ua.indexOf('rv:11.0') !== -1 || ua.indexOf('MSIE') !== -1;
	// var isIEnotEdge = isIE && ua.indexOf('Edge') == -1;
	// if( isIE ) document.body.className += ' ie';
});


/*
* 	@ Preloader-done event
*/

$j(window).on('preloader-done',function(){

	// animate elems after preloader is done
	animateElems();

	// check if hash isset
	// checkHashScroll('onload');

	// pageload
	// $j('.wrapper').addClass('page--loaded');
});


/*
*	@ Description:
* 	Singlepage Nav History Push Events
* 	listener for pushState: --> Back & Forward
*/

// var auto_title = 'Home';

// window.addEventListener('popstate', function popFunction(e) {
// 	if( e.state ){
// 		scrollTo( $j(e.state.id) );
// 		document.title = e.state.title;
// 	}else{
// 		document.title = auto_title;
// 		scrollTo();
// 	}
// });


///////////////////////////
//////// Functions ////////
///////////////////////////


/*
*  @Description:
*  Scroll to given Elements top position with a given duration
*  If no params are provided, default operation is to scroll to top : 0
*/

function scrollTo( elem, dur ){
	// check for given params and assign defaults
	// ( default parameter values is not Crossbrowser safe )
	var pos;
	if( typeof elem == 'undefined' ){
		pos = 0;
	}else{
		pos = elem.offset().top;
	}

	if( typeof dur == 'undefined' ){
		dur = 1000;
	}

	// animate
	$j('html, body').stop().animate( { scrollTop: pos}, dur );

	// with success call if needed
	// $j('html, body').stop().animate( { scrollTop: pos}, dur ).promise().then(function(){
	//  operations
	// });

}


/*
*  @Description:
*  Check scroll pos and apply fixed-header body class
*/

function fixedHeader(){

	var body = $j('body');
	if($j(window).scrollTop() > 0 ){
		body.addClass('fixed-header');
	}else{
		body.removeClass('fixed-header');
	}

}


/*
*  @Description:
*  check scrollPos and show Back to top if needed
*/

function checkBtt(){

	var btt = $j('#btt');
	if( btt.length ){
		if( lastPos > $j(window).height() / 2 ){ // if half of viewport is scrolled down
			btt.addClass('show');
		}else{
			btt.removeClass('show');
		}
	}

}


/*
*  @Description:
*  loop through element with the "anim" class and add the class that starts a CSS transition
*/

function animateElems(){

	// only the elems which havent been animated yet
	var elems = $j('.anim').not('.animated');
	elems.each(function(){
		if( isElementInViewport($j(this)) ){
			$j(this).addClass('animated');
		}
	});

}


/*
*  @Description:
*  checks if the given element is currently in viewport
*/





function isElementInViewport( elem ) {

	// @ offset Vars
	var fadeIn_offset = 150; // pixel offset
	// var fadeIn_offset = Math.floor($j(window).height() / 3); // viewport offset ; third from viewport

	var $elem = jQuery(elem);
	var $window = jQuery(window);

	var docViewTop = $window.scrollTop();
	var docViewBottom = docViewTop + $window.height();

	// if we are on top and given offset is bigger than current scroll pos, prevent negative offset error
	// 20 is the minimum value for elemTop offset value
	var elemTop = ($elem.offset().top - fadeIn_offset) > 0 ? $elem.offset().top - fadeIn_offset : 20;
	var elemBottom = elemTop + $elem.height();

	// check if curent module is taller than window
	// -> if so , fade In either when top or bottom - edge of the element is in viewport
	if( $elem.innerHeight() > $window.innerHeight() ){

		// scrolled DOWN
		if( docViewTop < lastPos ){

			if( elemBottom < docViewBottom ){
				return true;
			}

		// scrolled UP
		}else{

			if ( elemTop > docViewTop ){
				return true;
			}

		}
	// element is not taller than window height
	}else{

		if( ((elemBottom <= docViewBottom) && (elemTop >= docViewTop)) ){
			return true;
		}

	}
	// return false if nothing matched
	return false;

}

/*
*  Mobile: tabs to accordeon
*  @plugin: https://github.com/patlux/bootstrap-tabcollapse
*  @Description:
*  searches for BS tabs module and changes DOM to BS Tabs
*  Uncomment if needed
*/

// function BS_TabsToAccordion(){

// 	if( $j('.nav-tabs').length ){
// 		$j('.nav-tabs').tabCollapse({
// 			tabsClass: 'hidden-tablet-portrait-down',
//     		accordionClass: 'visible-tablet-portrait-down'
// 		});
// 	}

// }

/*
*  Hash Scroll Operations
*  @Description:
*  @type: click | load
*/

function checkHashScroll(type){

	var href;

	// define href, wheter its after page load or click
	if( type == 'onload' ){
		href = window.location.href;
	}else{
		href = type.attr('href');
	}

	// check if has hash
	if( href.indexOf('#') !== -1 ){
		// extract hash -> part after # is id of section
		var hash = href.split('#');
		var section = $j( '#' + hash[1] );
		// check if according elem to hash exists
		if( section.length ){
			scrollTo(section);
		}else{
			scrollTo(); // top is default
		}
	}

}



// Funktion, um das Element zu überprüfen, wenn es im Viewport ist

        // Funktion zum Zählen der Zahl
        function countToValue(targetElement, targetValue) {
            var current = 0;
            var increment = targetValue / 100; // Ändere 100 zu einem anderen Wert für die Geschwindigkeit

            function updateCounter() {
                if (current < targetValue) {
                    current += increment;
                    targetElement.text(Math.round(current));
                    requestAnimationFrame(updateCounter);
                } else {
                    targetElement.text(targetValue);
                }
            }

            updateCounter();
        }







// VIDEO ELEMENTS
var myVideo = document.getElementById("myVideo");
var playPauseBtn = document.getElementById("playPauseBtn");
var volumeBtn = document.getElementById("volumeBtn");
var overlay = document.getElementById("videooverlay");
var h2 = document.getElementById("videotitle");

// Prüfen, ob die Elemente auf der Seite vorhanden sind, bevor sie als Variablen definiert werden
if (playPauseBtn) {
  playPauseBtn.addEventListener("click", function() {
    if (myVideo.paused) {
      myVideo.play();
      playPauseBtn.classList.add("playing");
      playPauseBtn.classList.remove("paused");
      if (overlay) {
        overlay.style.opacity = "0";
      }
      if (h2) {
        h2.style.opacity = "0";
      }
    } else {
      myVideo.pause();
      playPauseBtn.classList.add("paused");
      playPauseBtn.classList.remove("playing");
      if (overlay) {
        overlay.style.opacity = "1";
      }
      if (h2) {
        h2.style.opacity = "1";
      }
    }
  });
}

if (volumeBtn) {
  volumeBtn.addEventListener("click", function() {
    if (myVideo.muted) {
      myVideo.muted = false;
      volumeBtn.classList.remove("muted");
    } else {
      myVideo.muted = true;
      volumeBtn.classList.add("muted");
    }
  });
}

if (myVideo) {
  myVideo.addEventListener("play", function() {
    if (playPauseBtn) {
      playPauseBtn.classList.add("playing");
      playPauseBtn.classList.remove("paused");
    }
    if (overlay) {
      overlay.style.opacity = "0";
    }
    if (h2) {
      h2.style.opacity = "0";
    }
  });

  myVideo.addEventListener("pause", function() {
    if (playPauseBtn) {
      playPauseBtn.classList.add("paused");
      playPauseBtn.classList.remove("playing");
    }
    if (overlay) {
      overlay.style.opacity = "1";
    }
    if (h2) {
      h2.style.opacity = "1";
    }
  });
}

// =============================================
// MEGA MENU
// =============================================
(function() {
  var header    = document.querySelector('.site-header');
  var trigger   = document.querySelector('.site-nav__item--has-mega');
  var megaMenu  = document.getElementById('megaMenu');

  if (!trigger || !megaMenu) return;

  var closeTimer;

  function openMega() {
    clearTimeout(closeTimer);
    megaMenu.classList.add('is-open');
    megaMenu.setAttribute('aria-hidden', 'false');
  }

  function closeMega() {
    closeTimer = setTimeout(function() {
      megaMenu.classList.remove('is-open');
      megaMenu.setAttribute('aria-hidden', 'true');
    }, 200);
  }

  trigger.addEventListener('mouseenter', openMega);
  trigger.addEventListener('mouseleave', closeMega);
  megaMenu.addEventListener('mouseenter', function() { clearTimeout(closeTimer); });
  megaMenu.addEventListener('mouseleave', closeMega);

  trigger.querySelector('.site-nav__link').addEventListener('click', function(e) {
    e.preventDefault();
    megaMenu.classList.toggle('is-open');
  });

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') closeMega();
  });

  document.addEventListener('click', function(e) {
    if (header && !header.contains(e.target)) closeMega();
  });
})();
